export { default } from './PatientMessagingHistoryTable';
